import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { PDP_SELECTION_VALIDITY_STATES, PDP_DECIDELATER_TAB_ID, PDP_CUSTOMIZE_TAB_ID, PDP_READYTOSHIP_TAB_ID } from 'commons/constants';
import useCart from 'data-hooks/useCart';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import useProductFavoriteV2 from 'data-hooks/useProductFavoriteV2';
import useUserCartEvent from 'data-hooks/useEvents/useUserCartEvent';
import useModularDetails from 'data-hooks/useModularDetails';
import useModularPDPCart from 'data-hooks/useModularPDPCart';
import { getCombinedOptionSKUs } from 'data-hooks/useProductLocalStock/utils';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPPrice from 'data-hooks/usePDPPrice';
import { getPriceDetailsUtil } from 'data-hooks/utils';
import useJbEventFBAddToCart from 'hooks/sendFBEventHooks/useJbEventFBAddToCart';
import lastInsightsClickAtom from 'components/consumer/consumer-search/advanced-search/atoms/lastInsightsClickAtom';
import { useAtom } from 'jotai';
import handleInsightsAddToCart from 'components/consumer/consumer-search/algolia-insights-helpers/handleInsightsAddtoCart';
import { getDisplayedInsightsPricing } from 'components/consumer/consumer-search/algolia-insights-helpers/insightsObjectDataUtils';
import PDPAddToBagSectionUI from './PDPAddToBagSectionUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/usePdpSelectedProtectionPlanId';
import usePDPOptions from '../state/context/usePDPOptions';
import usePDPStockAvailability from '../state/context/usePDPStockAvailability';
import PDPAddToBagSectionPlaceholder from './PDPAddToBagSectionPlaceholder';
const PDPAddToBagSectionInner = t0 => {
  const $ = _c(57);
  const {
    mode: t1,
    onAddToCartClicked,
    pageLoading,
    productId: t2,
    slug: t3,
    stickyDesktopButtonOnly: t4,
    isEditOrder: t5
  } = t0;
  const mode = t1 === undefined ? "pdp" : t1;
  const productId = t2 === undefined ? null : t2;
  const slug = t3 === undefined ? null : t3;
  const stickyDesktopButtonOnly = t4 === undefined ? false : t4;
  const isEditOrder = t5 === undefined ? false : t5;
  const [addToCartError, setAddToCartError] = useState(null);
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {};
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  const [buildYourOwnDetails, updateBuildYourOwnDetails] = useState(t6);
  const [lastInsightsClick] = useAtom(lastInsightsClickAtom);
  const {
    isFavorited
  } = useProductFavoriteV2();
  const {
    data: priceData
  } = usePDPPrice();
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();
  const {
    loading: basicDetailsLoading,
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    loading: modularDetailsLoading,
    data: modularDetailsData
  } = useModularDetails(slug);
  const {
    data: t7,
    actions: t8
  } = useModularPDPCart(productId, slug);
  const {
    addingToCart: modularAddingToCart,
    modularTotalPrice
  } = t7;
  const {
    addModularToCart
  } = t8;
  const {
    loading: optionsLoading,
    data: optionData
  } = usePDPOptions();
  const {
    loading: availabilityLoading,
    data: t9
  } = usePDPStockAvailability();
  const {
    isEFGInternal,
    isMarkedOOSOrDiscontinued,
    isOutOfStock,
    isDiscontinued
  } = t9;
  const {
    data: t10,
    actions: t11
  } = useCart();
  const {
    addingToCart
  } = t10;
  const {
    addToCart
  } = t11;
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const {
    data: t12
  } = usePDPFabricFilters(slug, isEditOrder);
  const {
    selectedMaterial
  } = t12;
  let t13;
  if ($[1] !== priceData) {
    t13 = priceData || {};
    $[1] = priceData;
    $[2] = t13;
  } else {
    t13 = $[2];
  }
  const {
    isClearance,
    clearanceStockPerSKU
  } = t13;
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const isRTSTab = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID;
  let t14;
  bb0: {
    if (!priceData?.price) {
      let t15;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = {
          price: 0,
          discount: 0
        };
        $[3] = t15;
      } else {
        t15 = $[3];
      }
      t14 = t15;
      break bb0;
    }
    let t15;
    if ($[4] !== priceData.isClearance || $[5] !== priceData.optionPrice || $[6] !== priceData.price || $[7] !== priceData.promotion) {
      t15 = getDisplayedInsightsPricing(getPriceDetailsUtil(priceData.price, priceData.promotion, priceData.optionPrice, priceData.isClearance));
      $[4] = priceData.isClearance;
      $[5] = priceData.optionPrice;
      $[6] = priceData.price;
      $[7] = priceData.promotion;
      $[8] = t15;
    } else {
      t15 = $[8];
    }
    t14 = t15;
  }
  const insightsPricing = t14;
  const {
    addToCartEvent
  } = useUserCartEvent(basicDetails, optionData, priceData, isClearance, isFavorited);
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const pdpSelectedProtectionPlanId = usePdpSelectedProtectionPlanId();
  let t15;
  if ($[9] !== addModularToCart || $[10] !== addToCart || $[11] !== addToCartEvent || $[12] !== basicDetails || $[13] !== insightsPricing || $[14] !== lastInsightsClick || $[15] !== mode || $[16] !== onAddToCartClicked || $[17] !== optionData.selectedOptions || $[18] !== pdpIsModularBYOProduct || $[19] !== pdpSelectedCustomizerTab || $[20] !== pdpSelectedProtectionPlanId) {
    t15 = async () => {
      if (pdpIsModularBYOProduct) {
        addModularToCart({
          decideLater: pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID
        });
        return;
      }
      setAddToCartError(null);
      const {
        errors,
        cart,
        cartToken
      } = await addToCart({
        productId: basicDetails.id,
        selectedOptions: optionData.selectedOptions,
        decideLater: pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID,
        selectedProtectionPlanId: pdpSelectedProtectionPlanId
      });
      if (errors) {
        setAddToCartError(errors?.[0]?.message || "Unable to add to cart. Please try again.");
        return;
      }
      handleInsightsAddToCart({
        hit: lastInsightsClick,
        productId: basicDetails.id,
        price: insightsPricing.price,
        discount: insightsPricing.discount,
        quantity: 1
      });
      onAddToCartClicked?.();
      addToCartEvent(cart, cartToken, mode);
    };
    $[9] = addModularToCart;
    $[10] = addToCart;
    $[11] = addToCartEvent;
    $[12] = basicDetails;
    $[13] = insightsPricing;
    $[14] = lastInsightsClick;
    $[15] = mode;
    $[16] = onAddToCartClicked;
    $[17] = optionData.selectedOptions;
    $[18] = pdpIsModularBYOProduct;
    $[19] = pdpSelectedCustomizerTab;
    $[20] = pdpSelectedProtectionPlanId;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const onAddToCart = t15;
  let t16;
  let t17;
  if ($[22] !== isZipCodeFromUserServiceable) {
    t16 = () => {
      if (isZipCodeFromUserServiceable) {
        setAddToCartError(null);
      }
    };
    t17 = [isZipCodeFromUserServiceable];
    $[22] = isZipCodeFromUserServiceable;
    $[23] = t16;
    $[24] = t17;
  } else {
    t16 = $[23];
    t17 = $[24];
  }
  useEffect(t16, t17);
  let t18;
  bb1: {
    if (availabilityLoading || optionsLoading || modularDetailsLoading) {
      t18 = false;
      break bb1;
    }
    if (isEFGInternal || isEmpty(optionData?.options) || optionData?.pdpHasUserSelectedOptions || !optionData?.upholsteryOptionId || pdpSelectedCustomizerTab !== PDP_CUSTOMIZE_TAB_ID || optionData?.options.find(optValue => optValue.id === optionData?.upholsteryOptionId)?.values?.length === 1) {
      t18 = false;
      break bb1;
    }
    t18 = true;
  }
  const allowUserToCustomize = t18;
  let t19;
  bb2: {
    if (!!optionData.stock?.stockOptionsCombined?.length && isRTSTab) {
      const updatedDisabledState = getCombinedOptionSKUs(optionData.selectedOptionsVariantSku, optionData.stock?.stockOptionsCombined);
      t19 = updatedDisabledState;
      break bb2;
    }
    t19 = [];
  }
  const validStockOptionSkus = t19;
  let t20;
  bb3: {
    if (availabilityLoading || optionsLoading) {
      t20 = false;
      break bb3;
    }
    if (validStockOptionSkus?.length && optionData?.selectedOptionsVariantSku) {
      if (!validStockOptionSkus.includes(optionData?.selectedOptionsVariantSku)) {
        t20 = true;
        break bb3;
      }
    }
    if (!optionData?.stock?.stockOptions?.length || isOutOfStock) {
      t20 = isOutOfStock;
      break bb3;
    }
    const {
      selectionValidity
    } = optionData.stock;
    let t21;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = [PDP_SELECTION_VALIDITY_STATES.INVALID, PDP_SELECTION_VALIDITY_STATES.INACTIVE];
      $[25] = t21;
    } else {
      t21 = $[25];
    }
    t20 = t21.includes(selectionValidity);
  }
  const isCartDisabled = t20;
  let t21;
  if ($[26] !== basicDetails?.id || $[27] !== basicDetails?.meta?.collectionSlug || $[28] !== modularDetailsData.isModularBundleProduct || $[29] !== modularDetailsData.preConfigProducts) {
    t21 = () => {
      if (!modularDetailsData?.isModularBundleProduct || !modularDetailsData?.preConfigProducts?.length) {
        return;
      }
      const updatedProducts = modularDetailsData.preConfigProducts.filter(prod => !!prod && prod.id !== basicDetails?.id);
      let finalSlug = basicDetails?.meta?.collectionSlug ? basicDetails?.meta?.collectionSlug.replace("collections/", "") : "";
      finalSlug = finalSlug.length ? `${finalSlug.charAt(0).toUpperCase()}${finalSlug.slice(1)}` : "";
      updateBuildYourOwnDetails({
        name: finalSlug,
        urlKey: `/modular/${finalSlug.toLowerCase()}-modular/`,
        dimensions: `Choose from ${updatedProducts.length} pieces to make any configuration.`
      });
    };
    $[26] = basicDetails?.id;
    $[27] = basicDetails?.meta?.collectionSlug;
    $[28] = modularDetailsData.isModularBundleProduct;
    $[29] = modularDetailsData.preConfigProducts;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  const t22 = basicDetails?.id;
  const t23 = basicDetails?.meta?.collectionSlug;
  const t24 = modularDetailsData?.isModularBundleProduct;
  let t25;
  if ($[31] !== modularDetailsData.preConfigProducts || $[32] !== t22 || $[33] !== t23 || $[34] !== t24) {
    t25 = [t22, t23, t24, modularDetailsData.preConfigProducts];
    $[31] = modularDetailsData.preConfigProducts;
    $[32] = t22;
    $[33] = t23;
    $[34] = t24;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  useEffect(t21, t25);
  const t26 = optionData?.selectedOptionsVariantSku;
  let t27;
  if ($[36] !== basicDetails || $[37] !== t26) {
    t27 = {
      basicDetails,
      selectedOptionsVariantSku: t26
    };
    $[36] = basicDetails;
    $[37] = t26;
    $[38] = t27;
  } else {
    t27 = $[38];
  }
  useJbEventFBAddToCart(t27);
  const loading = basicDetailsLoading || optionsLoading || pageLoading || modularDetailsLoading;
  const t28 = pdpIsModularBYOProduct ? modularAddingToCart : addingToCart;
  const t29 = loading || isCartDisabled || pdpIsModularBYOProduct && !modularTotalPrice || isMarkedOOSOrDiscontinued && (isOutOfStock || isDiscontinued);
  const t30 = basicDetails?.meta?.collectionSlug;
  const t31 = modularDetailsData?.isModularBundleProduct;
  const t32 = !loading ? onAddToCart : undefined;
  const t33 = basicDetails?.meta?.price?.final_price;
  const t34 = isClearance && !clearanceStockPerSKU?.flashSale && !isDecideLaterTab;
  const t35 = basicDetails?.custom_properties?.campaign;
  let t36;
  if ($[39] !== addToCartError || $[40] !== allowUserToCustomize || $[41] !== buildYourOwnDetails || $[42] !== isDiscontinued || $[43] !== isOutOfStock || $[44] !== loading || $[45] !== mode || $[46] !== selectedMaterial || $[47] !== stickyDesktopButtonOnly || $[48] !== t28 || $[49] !== t29 || $[50] !== t30 || $[51] !== t31 || $[52] !== t32 || $[53] !== t33 || $[54] !== t34 || $[55] !== t35) {
    t36 = <PDPAddToBagSectionUI addToCartError={addToCartError} addingToCart={t28} allowUserToCustomize={allowUserToCustomize} buildYourOwnDetails={buildYourOwnDetails} cartDisabled={t29} collectionSlug={t30} isDiscontinued={isDiscontinued} isModularBundleProduct={t31} isOutOfStock={isOutOfStock} loading={loading} mode={mode} onAddToCart={t32} price={t33} showClearanceAlert={t34} stickyDesktopButtonOnly={stickyDesktopButtonOnly} campaign={t35} selectedMaterial={selectedMaterial} />;
    $[39] = addToCartError;
    $[40] = allowUserToCustomize;
    $[41] = buildYourOwnDetails;
    $[42] = isDiscontinued;
    $[43] = isOutOfStock;
    $[44] = loading;
    $[45] = mode;
    $[46] = selectedMaterial;
    $[47] = stickyDesktopButtonOnly;
    $[48] = t28;
    $[49] = t29;
    $[50] = t30;
    $[51] = t31;
    $[52] = t32;
    $[53] = t33;
    $[54] = t34;
    $[55] = t35;
    $[56] = t36;
  } else {
    t36 = $[56];
  }
  return t36;
};
PDPAddToBagSectionInner.propTypes = {
  mode: PropTypes.oneOf(['quickview', 'pdp']),
  onAddToCartClicked: PropTypes.func,
  pageLoading: PropTypes.bool,
  productId: PropTypes.number,
  slug: PropTypes.string,
  stickyDesktopButtonOnly: PropTypes.bool,
  isEditOrder: PropTypes.bool
};
const PDPAddToBagSection = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPAddToBagSectionPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPAddToBagSectionInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPAddToBagSection;